import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Menu,
  MenuItem,
  Button,
  Fade,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { BASE_API_URL, BASE_FRONT_URL } from "../config";

/* 🔤 MENU LABEL → DB TABLE */
const menuMap = {
  uz: {
    "BO‘LIM": "menus_department",
    "TADQIQOT": "menus_research",
    "TA’LIM": "menus_teaching",
    "AKADEMIK INFRASTRUKTURA": "menus_academic",
  },
  ru: {
    "ОТДЕЛ": "menus_department",
    "ИССЛЕДОВАНИЯ": "menus_research",
    "ОБРАЗОВАНИЕ": "menus_teaching",
    "АКАДЕМИЧЕСКАЯ ИНФРАСТРУКТУРА": "menus_academic",
  },
  en: {
    "THE DEPARTMENT": "menus_department",
    "RESEARCH": "menus_research",
    "TEACHING": "menus_teaching",
    "ACADEMIC INFRASTRUCTURE": "menus_academic",
  },
};

const TopNavbar = () => {
  const [language, setLanguage] = useState(
    (localStorage.getItem("language") || "uz").slice(0, 2)
  );

  const [menus, setMenus] = useState({});
  const [anchorEls, setAnchorEls] = useState({});
  const [openMenu, setOpenMenu] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  /* ============================
     MENYULARNI YUKLASH
  ============================ */
  useEffect(() => {
    const fetchMenus = async () => {
      const fetchedMenus = {};

      for (const label in menuMap[language]) {
        const tableName = menuMap[language][label];

        try {
          const res = await fetch(`${BASE_API_URL}/topmenu/${tableName}`);
          const data = await res.json();

          if (Array.isArray(data) && data.length > 0) {
            fetchedMenus[label] = data.map((item) => ({
              ...item,
              tableName,
            }));
          }
        } catch (err) {
          console.error(`❌ ${label} menyusida xato`, err);
        }
      }

      setMenus(fetchedMenus);
    };

    fetchMenus();
  }, [language]);

  /* ============================
     LANGUAGE CHANGE LISTENER
  ============================ */
  useEffect(() => {
    const handler = () => {
      const lang = (localStorage.getItem("language") || "uz").slice(0, 2);
      setLanguage(lang);
    };

    window.addEventListener("languageChanged", handler);
    return () => window.removeEventListener("languageChanged", handler);
  }, []);

  /* ============================
     MENU HANDLERS
  ============================ */
  const handleOpen = (e, label) => {
    setAnchorEls((prev) => ({ ...prev, [label]: e.currentTarget }));
    setOpenMenu(label);
  };

  const handleClose = () => {
    setOpenMenu(null);
  };

  const handleItemClick = (item) => {
    const url = item.link
      ? item.link.startsWith("http")
        ? item.link
        : `${BASE_FRONT_URL}${item.link}`
      : `${BASE_FRONT_URL}/page/${item.tableName}/${item.id}`;

    window.location.href = url;
    handleClose();
  };

  return (
    <>
      <AppBar position="fixed" sx={{ backgroundColor: "#001f3f", mt: "100px" }}>
        <Toolbar sx={{ justifyContent: "flex-end" }}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              justifyContent: isMobile ? "center" : "flex-end",
              width: "100%",
            }}
            onMouseLeave={handleClose}
          >
            {Object.keys(menus).length === 0 ? (
              <span style={{ color: "#fff" }}>⚠️ Menyular yo‘q</span>
            ) : (
              Object.entries(menus).map(([label, items]) => (
                <Box key={label}>
                  <Button
                    sx={{ color: "#fff", fontWeight: 600 }}
                    onClick={(e) => handleOpen(e, label)}
                  >
                    {label}
                  </Button>

                  <Menu
                    anchorEl={anchorEls[label]}
                    open={openMenu === label}
                    onClose={handleClose}
                    TransitionComponent={Fade}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                  >
                    {items.map((item) => (
                      <MenuItem
                        key={item.id}
                        onClick={() => handleItemClick(item)}
                      >
                        {item[`title_${language}`] || item.title_uz}
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>
              ))
            )}
          </Box>
        </Toolbar>
      </AppBar>

      {/* OFFSET */}
      <Toolbar sx={{ minHeight: 70 }} />
    </>
  );
};

export default TopNavbar;
